import React, { useCallback, useEffect, useState, useMemo } from "react";
import {
  HashRouter as Router,
  Route,
  Switch,
  Redirect
} from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "./App.scss";

import AddUser from "./components/AddUser/addUser";
import AddCustomer from "./components/AllNewCustomers/AddCustomers/AddCustomer";
import CollectionReport from "./components/CollectionReports/CollectionReport";
import EditCompanyProfile from "./components/company profile/EditCompanyProfile/editcompanyprofile";
import CompanyProfileDetails from "./components/CompanyProfileDetails/CompanyProfileDetails";
import AddLoanWithoutInterest from "./components/CustomersInfoRelatedLoans/AddLoanWithoutInterest/AddLoanWithoutInterest";
import AddFeeDetails from "./components/CustomersInfoRelatedLoans/AddFeeDetails/AddFeeDetails";
import Customer from "./components/CustomersInfoRelatedLoans/Customer";
import CustomerDetails from "./components/CustomersInfoRelatedLoans/CustomerDetails/CustomerDetails";
import Dashboard from "./components/Dashboard/Dashboard";
import EditCollectorProfile from "./components/Editcollector/editcollector";
import EditLoan from "./components/LoanType/EditLoan/EditLoan";
import AddLoanType from "./components/LoanType/AddLoanType/AddLoanType";
import Loan from "./components/LoanType/Loan";
import Login from "./components/login/login";
import CollectorWiseReport from "./components/Reports/CollectorWiseReport/index";
import CustomerWiseReport from "./components/Reports/CustomerWiseReport/index";
import LoanWiseReport from "./components/Reports/LoanWiseReport/index";
import SavingsWiseReport from "./components/Reports/SavingsWiseReport/SavingsWiseReport";
import CustomerWiseSavingsReport from "./components/Reports/CustomerWiseSavingsReport/CustomerWiseSavingsReport";
import DayWiseSavingsReport from "./components/Reports/DayWiseSavingsReport/DayWiseSavingsReport";
import LoanBeyondLoanTenure from "./components/Reports/LoanBeyondLoanTenure/LoanBeyondLoanTenure";
import ArrearReport from "./components/Reports/ArrearReport/index";
import LongPendingDues from "./components/Reports/LongPendingDues/LongPendingDues";
import DisburseReport from "./components/Reports/DisburseReport";
import RejectionReport from "./components/Reports/RejectionReport";
import Usermanagement from "./components/usermanagement/usermanagement";
import AllNewCustomers from "./components/AllNewCustomers/AllNewCustomer";
import ForgetPassword from "./components/login/ForgetPassword/ForgetPassword";
import ResetPassword from "./components/login/ResetPassword/ResetPassword";
import Help from "./components/Help/Help";
import NotFound from "./components/NotFound/NotFound";
import NetworkDetector from "./NetworkDetector";
import TermsOfService from "./components/modals/TermsOfService/TermsOfService";
import PrivacyPolicy from "./components/modals/PrivacyPolicy/PrivacyPolicy";
import OtpSignin from "./components/login/OtpSignin/OtpSignin";
import GoogleSignin from "./components/login/GoogleSignin/GoogleSignin";
import { auth } from "./firebase/config";
import LoadingPage from "./components/modals/LoadingPage/LoadingPage";
import SignUp1 from "./components/login/Signup/Signup";
import {
  checkUser,
  creategoogleuser,
  getCompanyProfile,
  getUserDetails,
  notPaidLoginCheck,
} from "./api";
import csvImportExport from "./components/csvImportExport";
import loanCsvImport from "./components/loanCsvImport";
import Pricing from "./components/Pricing";
import Expenses from "./components/Expenses/Expenses";
import ExpenseTypes from "./components/Expenses/ExpenseTypes";
import OtherIncome from "./components/OtherIncome/OtherIncome";
import OtherIncomeTypes from "./components/OtherIncome/OtherIncomeTypes";
import BankAccountManagement from "./components/BankAccountManagement/BankAccountManagement";
import AssetTypes from "./components/AssetManagement/AssetTypes";
import Assets from "./components/AssetManagement/Assets";
import AddUpdateAsset from "./components/AssetManagement/AddUpdateAsset";
import PrintDocs from "./components/PrintDocs/PrintDocs";
import LoanDisbursement from "./components/LoanDisbursement/LoanDisbursement";
import Settings from "./components/Settings/Settings";
import ProtectedRoute from "./ProtectedRoute";
import NotFoundPage from "./NotFoundPage";
import BorrowerAccessPage from "./BorrowerAccessPage";
import { getUserTypeDetails, getAllSettings, getSecureItem, setSecureItem, removeSecureItem } from "./utilsFunctions";
import UpdateAdminProfile from './components/updateAdmin/updateadminprofile'
import DetailedAnalysisReport from "./components/Reports/DetailedAnalysisReport";
import Axios from "axios";
import { BaseUrl, ImageBaseUrl } from "./Environment";
import PlanEnded from "./components/PlanEnded/PlanEnded";
import CustomPayment from "./components/CustomPayment";
import ProfitLoss from "./components/Accounting/ProfitLoss";
import BorrowerAccountStatement from "./components/Reports/BorrowerAccountStatement/BorrowerAccountStatement";
import CashFlow from "./components/CashFlow/CashFlow";
import AddInvestor from "./components/Investor/AddInvestor/addInvestor";
import ViewInvestor from "./components/Investor/ViewInvestor/viewInvestor";
import AddCollateral from "./components/Collateral/AddCollateral/addCollateral";
import ViewCollateral from "./components/Collateral/ViewCollateral/viewCollateral";
import axios from "axios";
import Partner from "./components/Partner/Partner";
import Branch from "./components/Branch/Branch";
import NewDashboard from "./components/NewDashboard/NewDashboard";
import OutstandingDuesReport from "./components/Reports/OutstandingDuesReport";
import Tickets from "./components/Tickets/Tickets";
import AddScheme from "./components/Deposits/Schemes/AddScheme";
import Schemes from "./components/Deposits/Schemes/Schemes";
import AddSaving from "./components/Deposits/Savings/AddSavings";
import Savings from "./components/Deposits/Savings/Savings";
import SavingDetails from "./components/Deposits/Savings/SavingDetails";

// Move static functions outside component
const isAuthenticated = () => !!getSecureItem("token");
const isLoggedIn = () => !!getSecureItem("loggedinUser");
const isCountryAvl = () => !!getSecureItem("country");

const TOKEN_REFRESH_INTERVAL = 30 * 60 * 1000; // 30 minutes

const startTokenRefresh = () => {
  const refreshToken = async () => {
    try {
      const user = auth.currentUser;
      if (!user) return;

      const idToken = await user.getIdToken(true); // force refresh
      setSecureItem("token", idToken);

      console.log("Token refreshed and stored");
    } catch (err) {
      console.log("Token refresh error:", err);
    }
  };

  // run once immediately
  refreshToken();

  // then run every 30 minutes
  const interval = setInterval(refreshToken, TOKEN_REFRESH_INTERVAL);

  return interval;
};

const App = () => {
  const history = useHistory();
  //const location = useLocation();
  const loggedinUser = useMemo(() => getSecureItem("loggedinUser"), []);

  const [user, setUser] = useState();
  const [loading, setLoading] = useState(false);

  const companyData = () => {
    getCompanyProfile()
      .then((resp) => {
        if (resp) {
          setSecureItem("country", resp.country);
        }
      })
      .catch((err) => {
        console.log({ err });
      });
  };

  const getStatus = (planenddate) => {
    const currentDate = new Date();
    const endDate = new Date(planenddate);
    const diffTime = endDate - currentDate;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // Difference in days

    if (diffDays < 0) {
      return {
        message: "Your plan has expired! ⚠️ Renew now to regain access to LendStack.",
        expired: true,
        abouttoexpire: false,
      };
    } else if (diffDays <= 3) {
      return {
        message:
          "Your plan is about to expire! Renew now to continue using LendStack without any interruptions.",
        expired: false,
        abouttoexpire: true,
      };
    } else {
      return {
        message: "✅ Your plan is active! Enjoy uninterrupted access to LendStack.",
        expired: false,
        abouttoexpire: false,
      };
    }
  };

  const updateCompany = async (companyId) => {
    try {
      const headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + getSecureItem("token"),
      };

      const companyData = {
        companyId,
        planId: 0,
        // tenure: "",
        // planPrice: null,
        // planStartDate: null,
        // planEndDate: null,
      };

      let formData = new FormData();
      formData.append('alldetails', JSON.stringify(companyData)); 

      const resp = await Axios.put(
        BaseUrl + "/company/putCompany",
        formData,
        {
          headers: headers,
        }
      );

      return resp;
    } catch (error) {
      console.log("error", error);
    }
  };

  const LoggedinUser = () => {
    getUserDetails(getSecureItem("firebaseUid"))
      .then(async (resp) => {
        if (resp?.userType == "Collection Agent") {
          toast.info(
            "Access is Denied. You have been added as Collection Agent by Your Company.",
            {
              position: "top-center",
              autoClose: 10000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: false,
              draggable: false,
            }
          );
        } else {
          if (resp?.isEOD) {
            const headers = {
              "Content-Type": "application/json",
              Authorization: "Bearer " + getSecureItem("token"),
            };

            // Get today's midnight (00:00 AM)
            const todayMidnight = new Date();
            todayMidnight.setHours(0, 0, 0, 0);

            // Get the EOD marked date (assuming dbUser.eodMarkedAt is an ISO string or timestamp)
            const eodMarkedDate = new Date(resp.updatedAt);
            eodMarkedDate.setHours(0, 0, 0, 0);

            if (eodMarkedDate < todayMidnight) {
              // EOD was marked on a previous day → reset isEOD and continue login
              await axios.put(`${BaseUrl}/user/updateIsEOD?userId=${resp.userId}`, {
                isEOD: false,
              }, {headers});
              resp.isEOD = false; // update local copy so login flow continues
            } else {
              // EOD marked today → block login
              localStorage.clear();
              await auth.signOut();
              history.push('/');
              return; // exit early
            }
          }
          if (resp.userId && resp.firstName && resp.lastName) {
            if (resp?.company?.planEndDate) {
              const { message, expired, abouttoexpire } = getStatus(
                resp?.company?.planEndDate
              );

              if (resp?.company?.planId != 0 && expired) {
                toast.info(message, {
                  position: "top-center",
                  autoClose: 10000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: false,
                });

                const response = await updateCompany(resp?.company?.companyId);
                if(response.data?.status){
                  window.location.reload();
                }
              } else if (abouttoexpire) {
                toast.info(message, {
                  position: "top-center",
                  autoClose: 10000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: false,
                  draggable: false,
                });
              }
            }
            notPaidLoginCheck(resp.userId);
            setSecureItem("userid", resp.userId);
            setSecureItem("loggedinUser", resp);
            setSecureItem("loggedinUserCompany",resp.companyId);
            setSecureItem("userTypeAY",resp?.userType);
            setSecureItem("defaultPhone",resp?.userPhone);
            setSecureItem("defaultEmail	",resp?.userEmail);
            getUserTypeDetails(resp.userType, resp.companyId,resp.userId);
            getAllSettings();
            companyData();

            const isFreshLogin = getSecureItem("isFreshLogin");
            if (isFreshLogin === "true") {
              removeSecureItem("isFreshLogin"); // clear flag
              history.push("/dashboard");
            }
            // setTimeout(() => {
            //   window.location.reload(true);
            // }, 500);
          } else {
            history.push("/signup/register");
          }
        }
      })
      .catch((error) => {
        console.log("login error is:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const onAuthStateChanged = useCallback((_user) => {
    if (_user) {
      setLoading(true);
    } else {
      setLoading(false);
      setUser(null);
    }

    auth.currentUser
      .getIdToken(/* forceRefresh */ true)
      .then(function (idToken) {
        setSecureItem("token", idToken);

        checkUser(_user.uid, _user.email)
          .then((res1) => {
            if (res1?.code === 200) {
              setUser(_user);
              setLoading(false);
              // if (!getSecureItem("loggedinUser")) {
                LoggedinUser(); // Load user data only on login
              // } else {
              //   getUserTypeDetails(loggedinUser?.userType, loggedinUser?.companyId,loggedinUser?.userId);
              //   getAllSettings();
              // }
            } else {
              const userType = getSecureItem("userTypeAY");

              const userData = {
                userEmail: _user.email,
                firebaseUid: _user.uid,
                userType: userType
              };

              creategoogleuser(userData)
                .then(async (res) => {
                  if (res?.code === 200) {
                    setUser(_user);
                  } else {
                    await auth.signOut();
                    removeSecureItem("token");
                  }
                })
                .catch((err) => {
                  console.log({ err });
                });
            }
          })
          .catch((err1) => {
            console.log({ err1 });
          });
      })
      .catch(function (error) {
        console.log({ error });
      });
  }, []);

  useEffect(() => {
    const subscriber = auth.onAuthStateChanged(onAuthStateChanged);
    return subscriber; // unsubscribe on unmount
  }, [onAuthStateChanged]);

  useEffect(() => {
    if (user) {
      setSecureItem("firebaseUid", user.uid);
      // setSecureItem("defaultEmail", user.email);
    }
  }, [user]);

  useEffect(() => {
    const interval = startTokenRefresh();

    return () => {
      if (interval) clearInterval(interval);
    };
  }, []);

  const getPartnerToken = async (code) => {
    try {
      const PaymentLinkBaseURL = `${ImageBaseUrl}api/razorPay`;
      const companyId = loggedinUser?.companyId;

      const { data } = await axios.post(
        `${PaymentLinkBaseURL}/partnerToken`,
        {
          companyId: companyId,
          client_id: "S67lnxsRooZNsc",
          client_secret: "yjnZ9IIgOamBDQXxGmKqjjG3",
          grant_type: "authorization_code",
          redirect_uri: "https://www.lendstack.app/",
          code: code
        },
      );

      if (data?.status) {
        console.log("data?.result",data?.result);
      }
    } catch (error) {
      console.log({error});
    }
  }
  
  const params = new URLSearchParams(window.location.search);
  const code = params.get("code");
  console.log({code});
  
  useEffect(() => {
    if(code){
      getPartnerToken(code);
    };
  }, [code])

  /*const shouldBlock =
  getSecureItem("token") && location.pathname !== "/pricing" &&
  loggedinUser?.company?.planEndDate &&
  getStatus(loggedinUser.company.planEndDate).expired;
 
  if (shouldBlock) return <PlanEnded />;*/

  if (loading) {
    return <LoadingPage isLoading={loading} />;
  }

  if (loggedinUser?.userType == "borrower") {
    return <BorrowerAccessPage />;
  }

  return (
    <Router>
      <Switch>
        {/* Common Routes */}
        {/* <Route
          exact
          path={[
            "/login",
            "/otpsignin",
            "/googlesignin",
            "/signup/register",
            "/signup",
            "/aboutus",
            "/contact",
          ]}
          component={Header}
        /> */}
        <Route exact path="/settings" render={() => (isLoggedIn() ? <Settings /> : <Redirect to="/notfound" />)} />

        <Route exact path="/login" component={Login} />
        <Route exact path="/otpsignin" render={() => (isLoggedIn() ? <Redirect to="/dashboard" /> : isCountryAvl() ? <OtpSignin /> : <Redirect to="/login" />)} />
        {/* <Route exact path="/otpsignin" component={OtpSignin} /> */}
        
        <Route exact path="/googlesignin" render={() => (isLoggedIn() ? <Redirect to="/dashboard" /> : isCountryAvl() ? <GoogleSignin /> : <Redirect to="/login" />)} />
        {/* <Route exact path="/googlesignin" component={GoogleSignin} /> */}
        <Route exact path="/forgetpassword" component={ForgetPassword} />
        <Route
          exact
          path="/completemyregistration"
          component={ForgetPassword}
        />
        <Route exact path="/reset" component={ResetPassword} />
        <Route exact path="/signup/register" render={() => (isLoggedIn() ? <Redirect to="/dashboard" /> : isAuthenticated() ? <SignUp1 /> : <Redirect to="/login" />)} />
        {/* <Route exact path="/signup/register" component={SignUp1} /> */}
        <Route exact path="/help" component={Help} />
        <Route exact path="/termsofservice" component={TermsOfService} />
        <Route exact path="/privacypolicy" component={PrivacyPolicy} />
        <Route exact path="/notfound" component={NotFoundPage} />

        {/* Automatically redirect based on token */}
        <Route
          exact
          path="/"
          render={() => (isLoggedIn() ? <Redirect to="/dashboard" /> : <Redirect to="/login" />)}
        />

        {/* Common with User/DB Details */}
        <Route exact path="/dashboard" component={NewDashboard} />
        <Route exact path="/newdashboard" component={NewDashboard} />
        <Route exact path="/usermanagement" component={Usermanagement} />
        <Route exact path="/companyprofile" component={CompanyProfileDetails} />
        <Route exact path="/pricing" component={Pricing} />
        <Route
          exact
          path="/bankaccountmanagement"
          component={BankAccountManagement}
        />
        <Route exact path="/loantype" component={Loan} />
        <Route
          exact
          path="/customers/customerinfo"
          component={CustomerDetails}
        />
        <Route exact path="/tickets" component={Tickets} />

        {/* Protected Routes */}
        <ProtectedRoute
          exact
          path="/addloannointerest"
          component={AddLoanWithoutInterest}
          requiredPermission="addLoan"
        />
        <ProtectedRoute
          exact
          path="/loan/loanCsvImport"
          component={loanCsvImport}
          requiredPermission="addLoan"
        />
        <ProtectedRoute
          exact
          path="/customer"
          component={Customer}
          requiredPermission="viewLoan"
        />
        <ProtectedRoute
          exact
          path="/customer/:filter"
          component={Customer}
          requiredPermission="viewLoan"
        />
        <ProtectedRoute
          exact
          path="/loandisbursement"
          component={LoanDisbursement}
          requiredPermission="approveLoan"
        />
        <ProtectedRoute
          exact
          path="/printdocs"
          component={PrintDocs}
          requiredPermission="printDocs"
        />
        <ProtectedRoute
          exact
          path="/companyprofile/edit"
          component={EditCompanyProfile}
          requiredPermission="editProfile"
        />
        <ProtectedRoute
          exact
          path="/partner"
          component={Partner}
          requiredPermission="editProfile"
        />
        <ProtectedRoute
          exact
          path="/branch"
          component={Branch}
          requiredPermission="editProfile"
        />
        <ProtectedRoute
          exact
          path="/usermanagement/adduser"
          component={AddUser}
          requiredPermission="addUsers"
        />
        <ProtectedRoute
          exact
          path="/usermanagement/editcollector"
          component={EditCollectorProfile}
          requiredPermission="editUsers"
        />
        <ProtectedRoute
          exact
          path="/expenses"
          component={Expenses}
          requiredPermission="Expenses"
        />
        <ProtectedRoute
          exact
          path="/expensetypes"
          component={ExpenseTypes}
          requiredPermission="Expenses"
        />
        <ProtectedRoute
          exact
          path="/custompayment"
          component={CustomPayment}
          requiredPermission="accounting"
        />
        <ProtectedRoute
          exact
          path="/otherincome"
          component={OtherIncome}
          requiredPermission="accounting"
        />
        <ProtectedRoute
          exact
          path="/otherincometypes"
          component={OtherIncomeTypes}
          requiredPermission="accounting"
        />
        <ProtectedRoute
          exact
          path="/asset"
          component={Assets}
          requiredPermission="accounting"
        />
        <ProtectedRoute
          exact
          path="/assettypes"
          component={AssetTypes}
          requiredPermission="accounting"
        />
        <ProtectedRoute
          exact
          path="/addupdateasset"
          component={AddUpdateAsset}
          requiredPermission="accounting"
        />
        <ProtectedRoute
          exact
          path="/profitloss"
          component={ProfitLoss}
          requiredPermission="accounting"
        />
        <ProtectedRoute
          exact
          path="/addFeeDetails"
          component={AddFeeDetails}
          requiredPermission="viewLoan"
        />
        <ProtectedRoute
          exact
          path="/addloan"
          component={AddLoanType}
          requiredPermission="addLoanTypes"
        />
        <ProtectedRoute
          exact
          path="/viewInvestor"
          component={ViewInvestor}
          requiredPermission="addUsers"
        />
        <ProtectedRoute
          exact
          path="/addInvestor"
          component={AddInvestor}
          requiredPermission="editUsers"
        />
        <ProtectedRoute
          exact
          path="/loan/editloan"
          component={EditLoan}
          requiredPermission="editLoanTypes"
        />
        <ProtectedRoute
          exact
          path="/viewCollateral"
          component={ViewCollateral}
          requiredPermission="viewLoan"
        />
        <ProtectedRoute
          exact
          path="/schemes"
          component={Schemes}
          requiredPermission="viewLoan"
        />
        <ProtectedRoute
          exact
          path="/addeditscheme/:schemeId?"
          component={AddScheme}
          requiredPermission="viewLoan"
        />
        <ProtectedRoute
          exact
          path="/savings"
          component={Savings}
          requiredPermission="viewLoan"
        />
        <ProtectedRoute
          exact
          path="/savings/:savingId?"
          component={SavingDetails}
          requiredPermission="viewLoan"
        />
        <ProtectedRoute
          exact
          path="/addsaving"
          component={AddSaving}
          requiredPermission="viewLoan"
        />
        <ProtectedRoute
          exact
          path="/addCollateral"
          component={AddCollateral}
          requiredPermission="addLoan"
        />
        <ProtectedRoute
          exact
          path="/allnewcustomers"
          component={AllNewCustomers}
          requiredPermission="viewBorrowers"
        />
        <ProtectedRoute
          exact
          path="/customers/addcustomer"
          component={AddCustomer}
          requiredPermission="addBorrowers"
        />
        <ProtectedRoute
          exact
          path="/customers/csvImportExport"
          component={csvImportExport}
          requiredPermission="addBorrowers"
        />
        <ProtectedRoute
          exact
          path="/collectionreport"
          component={CollectionReport}
          requiredPermission="viewReports"
        />
        <ProtectedRoute
          exact
          path="/collectionreport/:filter"
          component={CollectionReport}
          requiredPermission="viewReports"
        />
        <ProtectedRoute
          exact
          path="/cashflow"
          component={CashFlow}
          requiredPermission="accounting"
        />
        <ProtectedRoute
          exact
          path="/customerwisereport"
          component={CustomerWiseReport}
          requiredPermission="viewReports"
        />
        <ProtectedRoute
          exact
          path="/collectorwisereport"
          component={CollectorWiseReport}
          requiredPermission="viewReports"
        />
        <ProtectedRoute
          exact
          path="/borroweraccountstatement"
          component={BorrowerAccountStatement}
          requiredPermission="viewReports"
        />
        <ProtectedRoute
          exact
          path="/loanwisereport"
          component={LoanWiseReport}
          requiredPermission="viewReports"
        />
        <ProtectedRoute
          exact
          path="/savingswisereport"
          component={SavingsWiseReport}
          requiredPermission="viewReports"
        />
        <ProtectedRoute
          exact
          path="/customerwisesavingsreport"
          component={CustomerWiseSavingsReport}
          requiredPermission="viewReports"
        />
        <ProtectedRoute
          exact
          path="/daywisesavingsreport"
          component={DayWiseSavingsReport}
          requiredPermission="viewReports"
        />
        <ProtectedRoute
          exact
          path="/loanbeyond"
          component={LoanBeyondLoanTenure}
          requiredPermission="viewReports"
        />
        <ProtectedRoute
          exact
          path="/ArrearReport"
          component={ArrearReport}
          requiredPermission="viewReports"
        />
        <ProtectedRoute
          exact
          path="/outstandingduesreport"
          component={OutstandingDuesReport}
          requiredPermission="viewReports"
        />
        <ProtectedRoute
          exact
          path="/longpendingdues"
          component={LongPendingDues}
          requiredPermission="viewReports"
        />
        <ProtectedRoute
          exact
          path="/disbursereport"
          component={DisburseReport}
          requiredPermission="viewReports"
        />
        <ProtectedRoute
          exact
          path="/rejectionreport"
          component={RejectionReport}
          requiredPermission="viewReports"
        />
        <ProtectedRoute
          exact
          path="/detailedanalysisreport"
          component={DetailedAnalysisReport}
          requiredPermission="viewReports"
        />
        <ProtectedRoute exact path="/updateadmin" component={UpdateAdminProfile} requiredPermission="editProfile" />

        {/* Not Found Route */}
        <Route path="**" component={NotFoundPage} />

        {/* Not being used anywhere */}
        {/* <Route exact path="/customers/addloan" component={AddLoan} /> */}
        {/* <Route exact path="/customers/allcustomerlist" component={AllCustomerListView} /> */}
        {/* <Route exact path="/registercompanyprofile" component={CompanyProfile} /> */}
        {/* <Route exact path="/verifynumber" component={VerifyNumber} /> */}
        {/* <Route exact path="/share" component={MessagingService} /> */}
        {/* <Route exact path="/updatepassword" component={UpdatePassword} /> */}
      </Switch>
    </Router>
  );
};

export default NetworkDetector(App);
